import React from 'react';

/**
 * The Pipeline hub. Embeds the CI/CD pipeline console (public/prototype-architecture.html) in
 * embed mode — its runnable pipelines, stage edit-icons (→ /admin/config/<stage>), terminal logs,
 * the animated extraction→training connector, and the live config popups all work in place.
 * Rendered in an isolated iframe so its console styling can't collide with the .mx admin theme.
 */
const PipelineHub: React.FC = () => (
  <iframe
    title="DocShawk pipeline"
    src={`${process.env.PUBLIC_URL || ''}/prototype-architecture.html?embed=1`}
    style={{ display: 'block', width: '100%', height: 'calc(100vh - 108px)', border: 0, borderRadius: 10 }}
  />
);

export default PipelineHub;
